import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import menuItemsSelector from '../../selectors/menuItems'

import MenuItem from './MenuItem'

import '../../styles/MenuItems.css'

class MenuItems extends Component {
  _renderItems () {
    const ItemComponent = this.props.itemComponent

    const {
      history,
      menuItems
    } = this.props

    return menuItems.map((menuItem) => {
      const key = `${menuItem.menuableType}-${menuItem.id}`

      if (ItemComponent) {
        return (<ItemComponent key={key} data={menuItem} history={history} />)
      }

      return (<MenuItem key={key} data={menuItem} history={history} />)
    })
  }

  render () {
    return (
      <ul className='MenuItems'>
        {this._renderItems()}
      </ul>
    )
  }
}

MenuItems.propTypes = {
  menuItems: PropTypes.array,
  itemComponent: PropTypes.func,
  history: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
  const { menuItems } = ownProps

  return {
    menuItems: menuItemsSelector(state, menuItems)
  }
}

export default connect(mapStateToProps)(MenuItems)



// WEBPACK FOOTER //
// ./src/components/menus/MenuItems.js